export default "__VITE_ASSET__9VuxNcWE__"